import { render, staticRenderFns } from "./SectionLoan.vue?vue&type=template&id=28e979d6&"
import script from "./SectionLoan.vue?vue&type=script&lang=js&"
export * from "./SectionLoan.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports